// service-worker.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServiceWorkerService {
  private isRegistered = false;
  private registration: ServiceWorkerRegistration | null = null;
  
  /**
   * Register Service Worker once only
   */
  async register(): Promise<ServiceWorkerRegistration | null> {
    // 1. Check browser support
    if (!('serviceWorker' in navigator)) {
      console.warn('Browser does not support Service Workers');
      return null;
    }
    
    // 2. Prevent duplicate registration
    if (this.isRegistered) {
      console.log('Service Worker already registered');
      return this.registration;
    }
    
    // 3. Only allow HTTPS or localhost
    const isLocal = window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1';
    if (window.location.protocol !== 'https:' && !isLocal) {
      console.warn('Service Worker requires HTTPS in production');
      return null;
    }
    
    try {
      // 4. Register Service Worker
      this.registration = await navigator.serviceWorker.register('/ngsw-worker.js', {
        scope: '/',
        //updateViaCache: 'none' // Critical for MSAL auth
      });
      
      this.isRegistered = true;
      console.log('Service Worker registered successfully');
      
      return this.registration;
      
    } catch (error) {
      console.error('Error registering Service Worker:', error);
      return null;
    }
  }
  
  /**
   * Check if Service Worker is already registered
   */
  isAlreadyRegistered(): boolean {
    return this.isRegistered;
  }
  
  /**
   * Get current registration instance
   */
  getRegistration(): ServiceWorkerRegistration | null {
    return this.registration;
  }
  
  /**
   * Unregister all Service Workers
   */
  async unregister(): Promise<boolean> {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(r => r.unregister()));
      
      this.isRegistered = false;
      this.registration = null;
      
      console.log('Service Workers unregistered');
      return true;
      
    } catch (error) {
      console.error('Error unregistering:', error);
      return false;
    }
  }
}